<template>
  <div class="collage-carousel">
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item"
        :class="{ visible: imageVisible[index] }"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
        >
      </div>
    </div>

    <!-- Modal -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
      >
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimado',

  setup() {

    const images = [
                              require('@/assets/2.webp'),

            require('@/assets/30997_11zon.webp'),
            require('@/assets/3.webp'),
            require('@/assets/4.webp'),


    ]

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)

    const collageItems = ref([])
    const imageVisible = ref(new Array(images.length).fill(false))

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    const observeImages = () => {

      const options = {
        threshold: 0.3
      }

      const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

          const index = collageItems.value.indexOf(entry.target)

          if (entry.isIntersecting && !imageVisible.value[index]) {

            imageVisible.value[index] = true

            animateIn(entry.target)

          }

        })

      }, options)

      collageItems.value.forEach((el) => {

        if (el) observer.observe(el)

      })

    }

    // 🌤️ ANIMACIÓN
    const animateIn = (el) => {

      gsap.fromTo(
        el,
        {
          opacity: 0,
          y: -260,
          scale: 0.9,
          rotateX: 18,
          filter: 'blur(10px)'
        },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          rotateX: 0,
          filter: 'blur(0px)',
          duration: 1.8,
          delay: 0.5,
          ease: 'power4.out'
        }
      )

    }

    onMounted(async () => {

      await nextTick()

      collageItems.value =
        collageItems.value.slice(0, images.length)

      observeImages()

    })

    return {
      images,
      currentIndex,
      isImageEnlarged,
      enlargeImage,
      closeModal,
      collageItems,
      imageVisible
    }
  }
}
</script><style scoped>
.collage-carousel{  width:100%;  max-width:100%;  padding:0;  margin:0;  display:block;  overflow:visible;  line-height:0;  /* 🔥 AGREGA ESTO */  padding-bottom:50px;  margin-bottom:-120px;  position:relative !important;  z-index:9 !important;  isolation:isolate;}

.collage-grid{
  display:grid;
  grid-template-columns:repeat(12,1fr);
  gap:0;

  overflow:visible;
  line-height:0;


  position:relative;
  z-index:1 !important;
}

.collage-item{
  grid-column:span 12;
  opacity:0;

  overflow:hidden;
  line-height:0;


  cursor:pointer;
  perspective:800px;

  position:relative;
  z-index:99999 !important;
}

.collage-item.visible{
  opacity:1;
}

.collage-image{
  width:100%;
  height:auto;
  object-fit:cover;


  position:relative;
  z-index:99999 !important;

  display:block;
  transition:transform .4s ease;
}

.collage-image:hover{
  transform:scale(1.04);
}

/* 🔥 FIX CONTRA ELEMENTOS FIXED */
.collage-carousel,
.collage-grid,
.collage-item,
.collage-image{
  transform:translateZ(0);
  will-change:transform;
}

/* Modal */
.image-modal{
  position:fixed;
  inset:0;
  background-color:rgba(10,10,10,.9);

  display:flex;
  align-items:center;
  justify-content:center;

  z-index:999999;
}

.enlarged-image{
  max-width:90%;
  max-height:90%;
  border-radius:12px;
  object-fit:contain;
}
</style>